import React , { useState , useEffect } from 'react';
import styled from 'styled-components';
import Circle from './image/circle.png'; 
import { LuLineChart } from "react-icons/lu";
import { IoBookmarkOutline } from "react-icons/io5";
import { RiVipDiamondLine } from "react-icons/ri";
import { TbShoppingCartDollar } from "react-icons/tb";
import { MdOutlineAddShoppingCart } from "react-icons/md";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { FaShopify } from "react-icons/fa6";
import { CiShoppingTag } from "react-icons/ci";
import { BiSolidPhoneCall } from "react-icons/bi";
import { RiCustomerService2Line } from "react-icons/ri";

import { Form, Container, Row, Col } from 'react-bootstrap';
//import './css/style.css';
import Image1 from "./image/faces/face1.jpg";
import Image2 from "./image/faces/face2.jpg";
import Image3 from "./image/faces/face3.jpg";
import Image4 from "./image/faces/face4.jpg";
import { VisitSaleChart } from './dashboard_script';
import { TrafficChart } from './dashboard_chart';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from "axios";
import { BASE_URL } from "../../App";
import {Backdrop, CircularProgress, } from '@mui/material';
// Styled components here

const tickets = [
  {
    image: Image1,
    assignee: 'David Grey',
    subject: 'Fund is not received',
    status: 'DONE',
    statusClass: 'success',
    lastUpdate: 'Dec 5, 2017',
    trackingId: 'WD-12345'
  },
  {
    image: Image2,
    assignee: 'Stella Johnson',
    subject: 'High loading time',
    status: 'PROGRESS',
    statusClass: 'warning',
    lastUpdate: 'Dec 12, 2017',
    trackingId: 'WD-12346'
  },
  {
    image: Image3,
    assignee: 'Marina Michel',
    subject: 'Website down for one week',
    status: 'ON HOLD',
    statusClass: 'info',
    lastUpdate: 'Dec 16, 2017',
    trackingId: 'WD-12347'
  },
  {
    image: Image4,
    assignee: 'John Doe',
    subject: 'Losing control on server',
    status: 'REJECTED',
    statusClass: 'danger',
    lastUpdate: 'Dec 3, 2017',
    trackingId: 'WD-12348'
  }
];

const Dashbord = () => {

  const [dashboardTotal, setDashboardTotal] = useState([]);
  const [dashboardCount, setDashboardCount] = useState([]);

  const [dashboardTotalPercentage, setDashboardTotalPercentage] = useState([]);
  const [dashboardCountPercentage, setDashboardCountPercentage] = useState([]);
  const [dashboardNetValue, setDashboardNetValue] = useState([]);
  const [dashboardNetCount, setDashboardNetCount] = useState([]);

  const [dashboardNetValuePercentage, setDashboardNetValuePercentage] = useState([]);
  const [dashboardNetCountPercentage, setDashboardNetCountPercentage] = useState([]);


  const [dashboardSalesCall, setDashboardSalesCall] = useState([]);
  const [dashboardServiceCall, setDashboardServiceCall] = useState([]);

  const [tableInvoice, setTableInvoice] = useState([]);

  const [currentBalance, setCurrentBalance] = useState([]);
  const [loading, setLoading] = useState([]);


  const [isCollapsed, setIsCollapsed] = useState(false);
  const login_id = localStorage.getItem("LOGIN_ID");
  const user_id = localStorage.getItem("USER_ID");
  const clientip = localStorage.getItem("clientip");
  
  const getRealTimeInfo = async () => {
    setLoading(true);
    try {
      const formData2 = new FormData();
      formData2.append('login_id', login_id);
      formData2.append('type', 'order');
      formData2.append('dealer_code', user_id);
  
      const config1 = {
        method: 'post',
        maxBodyLength: Infinity,
        url: BASE_URL + "/getrealtimeinfoordering",
        data: formData2
      };
  
      const response = await axios.request(config1);
      setCurrentBalance(response.data.dealer_details[0].CLOSING_BALANCE);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('real time', error);
    }
  };

  const dashboardView = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("login_id", login_id);
  
      const response = await axios.post(BASE_URL + "/dashboardView", formData);
  
      setLoading(false);
      setDashboardTotal(response.data.data[0].total_value[0]);
      setDashboardCount(response.data.data[0].count[0]);
      setDashboardTotalPercentage(response.data.percentage);
      setDashboardCountPercentage(response.data.percentage_count);
      setDashboardNetValue(response.data.net_value);
      setDashboardNetCount(response.data.net_count);
      setDashboardNetValuePercentage(response.data.net_count_percentage);
      setDashboardNetCountPercentage(response.data.net_value_percentage);
      setDashboardNetCountPercentage(response.data.net_value_percentage);
      setDashboardSalesCall(response.data.sales_call);
      setDashboardServiceCall(response.data.service_call);


      setTableInvoice(response.data.invoice);
      // setServiceClaimPending(response.data.service_claim[0].service_claim_pending);
      // setServiceClaimRejected(response.data.service_claim[0].service_claim_rejected);
  
    } catch (error) {
      setLoading(false);
      console.error('Error fetching dashboard data:', error);
    }
  };

  
  useEffect(() => {
    const fetchData = async () => {
      try {
         await Promise.all([getRealTimeInfo(), dashboardView()]);
      } catch (error) {
        console.error('Error during data fetching:', error);
      }
    };
  
    fetchData();
  }, []); // Empty dependency array ensures this runs once on mount
  
  
  console.log('data', dashboardTotal);
  const css = `
  .dashboard {
    background-image: linear-gradient(to right, #2e7fc2 0%, #6acad2 100%);
}

  .bg-danger-1 {
  background: linear-gradient(to right, #ffbf96, #fe7096) !important;
}

.bg-warning-2 {
  background: linear-gradient(to right, #FF896D, #D02610) !important;
}

.bg-danger-2 {
  background: linear-gradient(to right, #e8d8fc, #be8cf4) !important;
}
     
     .bg-gradient-info {
  background: linear-gradient(to right, #90caf9, #047edf 99%) !important;
}

.bg-gradient-info1 {
  background: linear-gradient(to right, #f1f296, #e3d52c) !important;
}

.bg-gradient-success {
  background: linear-gradient(to right, #84d9d2, #07cdae) !important;
}

.bg-gradient-sky {
  background: linear-gradient(to right, #98f7ed, #2cd5cf) !important;
}

center > button {
  position: relative;
  display: inline-block;
  cursor: pointer;
  outline: none;
  border: 0;
  vertical-align: middle;
  text-decoration: none;
  background: transparent;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
}

center > button.learn-more {
  width: 12rem;
  height: auto;
}

center > button.learn-more .circle {
  transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  position: relative;
  display: block;
  margin: 0;
  width: 3rem;
  height: 3rem;
  background: #282936;
  border-radius: 1.625rem;
}

center > button.learn-more .circle .icon {
  transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  background: #fff;
}

center > button.learn-more .circle .icon.up-arrow {
  top: 0.5rem;
  left: 0.625rem;
  width: 1.125rem;
  height: 0.125rem;
  background: none;
}

center > button.learn-more .circle .icon.up-arrow::before {
  position: absolute;
  content: "";
  top: 0;
  right: 0.0625rem;
  width: 0.625rem;
  height: 0.625rem;
  border-top: 0.125rem solid #fff;
  border-right: 0.125rem solid #fff;
  transform: rotate(-45deg);
}

center > button.learn-more .circle .icon.down-arrow {
  top: 0.5rem;
  left: 0.625rem;
  width: 1.125rem;
  height: 0.125rem;
  background: none;
}

center > button.learn-more .circle .icon.down-arrow::before {
  position: absolute;
  content: "";
  bottom: 0;
  right: 0.0625rem;
  width: 0.625rem;
  height: 0.625rem;
  border-bottom: 0.125rem solid #fff;
  border-left: 0.125rem solid #fff;
  transform: rotate(-45deg);
}

center > button.learn-more .button-text {
  transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0.75rem 0;
  margin: 0 0 0 1.85rem;
  color: #282936;
  font-weight: 700;
  line-height: 1.6;
  text-align: center;
  text-transform: uppercase;
}

center > button:hover .circle {
  width: 100%;
}

center > button:hover .circle .icon {
  background: #fff;
}

center > button:hover .button-text {
  color: #fff;
}

.card-body > h2 {
 
    display: inline-block;
    transition-duration: $defaultDuration;
    transition-property: transform;
    transition: all 0.3s ease-in-out;
    @include hideTapHighlightColor();
    @include hardwareAccel();
    @include improveAntiAlias();

    &:hover {
      /* transform: scale(1.1); */
      font-size: 44px;
    }
}

.card.card-img-holder {
  position: relative;
}
.card.card-img-holder .card-img-absolute {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  object-fit: cover;
}

  .grid-margin {
  margin-bottom: 1.1rem;
}


.badge {
  border-radius: 0.125rem;
  font-size: 11px;
  font-weight: initial;
  line-height: 1;
  padding: 0.375rem 0.5625rem;
  font-family: "ubuntu-medium", sans-serif;
}
.badge.badge-pill {
  border-radius: 10rem;
}

/*Badge variations*/
.badge-primary {
  border: 1px solid #b66dff;
  color: #ffffff;
  background: #b66dff;
}

.badge-secondary {
  border: 1px solid #c3bdbd;
  color: #ffffff;
  background: #c3bdbd;
}

.badge-success, .preview-list .preview-item .preview-thumbnail .badge.badge-online {
  border: 1px solid #1bcfb4;
  color: #ffffff;
  background: #1bcfb4;
}

.badge-info, .preview-list .preview-item .preview-thumbnail .badge.badge-offline {
  border: 1px solid #198ae3;
  color: #ffffff;
  background: #198ae3;
}

.badge-warning, .preview-list .preview-item .preview-thumbnail .badge.badge-busy {
  border: 1px solid #fed713;
  color: #ffffff;
  background: #fed713;
}

.badge-danger {
  border: 1px solid #fe7c96;
  color: #ffffff;
  background: #fe7c96;
}

.badge-light {
  border: 1px solid #f8f9fa;
  color: #ffffff;
  background: #f8f9fa;
}

.badge-dark {
  border: 1px solid #3e4b5b;
  color: #ffffff;
  background: #3e4b5b;
}

.me-2, .template-demo > .dropdown, .template-demo > .btn-group,
.template-demo > .btn-group-vertical, .template-demo > .btn, .ajax-upload-dragdrop .template-demo > .ajax-file-upload {
  margin-right: 0.5rem !important;
}

  .table td img {
  width: 36px;
  height: 36px;
  border-radius: 100%;
}

  .doughnutjs-wrapper {
  height: 250px !important;
}
@media (max-width: 991px) {
  .doughnutjs-wrapper {
    height: auto !important;
  }
}

  `
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="dashboard" 
    // style={{ backgroundColor: '#01e4f8', width: '100%', height: '100%' }}
    >
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>
    <style>{css}</style>
      <div className="container">
        <br/>
       
        <div id="dashboardCarousel" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <div className="row">
        {/* Card 1 */}
        <div className="col-md-3 col-lg-3 stretch-card grid-margin">
          <div className="card text-white bg-danger-1 card-img-holder">
            <div className="card-body">
              <img src={Circle} className="card-img-absolute" alt="circle-image"/>
              <h4 className="card-title d-flex justify-content-between align-items-center">
                Order Value<TbShoppingCartDollar />
              </h4>
              <h2 className="card-text mb-4">{ dashboardTotal.length > 0 ? dashboardTotal.order_value : 0 }</h2>
              <h6 className="card-subtitle mb-2">{dashboardTotalPercentage > 0 ? "Increased by" : "Decreased by"} {Math.round(dashboardTotalPercentage)}%</h6>
            </div>
          </div>
        </div>
        {/* Card 2 */}
        <div className="col-md-3 col-lg-3 stretch-card grid-margin">
          <div className="card bg-gradient-info card-img-holder text-white">
            <div className="card-body">
              <img src={Circle} className="card-img-absolute" alt="circle-image" />
              <h4 className="card-title d-flex justify-content-between align-items-center">Order Count<MdOutlineAddShoppingCart/></h4>
              <h2 className="mb-4">{ dashboardCount.length > 0 ? dashboardCount.order_count : 0 }</h2>
              <h6 className="card-text">{dashboardCountPercentage > 0 ? "Increased by" : "Decreased by"} {Math.round(dashboardCountPercentage)}%</h6>
            </div>
          </div>
        </div>
        {/* Card 3 */}
        <div className="col-md-3 col-lg-3 stretch-card grid-margin">
          <div className="card bg-gradient-success card-img-holder text-white">
            <div className="card-body">
              <img src={Circle} className="card-img-absolute" alt="circle-image" />
              <h4 className="card-title d-flex justify-content-between align-items-center">Balance <MdOutlineAccountBalanceWallet /></h4>
              <h2 className="mb-4">{currentBalance.length > 0 ? currentBalance : 0}</h2>
              <h6 className="card-text">{currentBalance > 0 ? "Debit" : "Credit"}</h6>
            </div>
          </div>
        </div>
        {/* Card 4 */}
        <div className="col-md-3 col-lg-3 stretch-card grid-margin">
          <div className="card text-white bg-warning-2 card-img-holder">
            <div className="card-body">
              <img src={Circle} className="card-img-absolute" alt="circle-image"/>
              <h4 className="card-title d-flex justify-content-between align-items-center">
                Sales Value<FaShopify />
              </h4>
              <h2 className="card-text mb-4">{ dashboardNetValue ? Math.round(dashboardNetValue) : 0 }</h2>
              <h6 className="card-subtitle mb-2">{dashboardNetValuePercentage > 0 ? "Increased by" : "Decreased by"} {Math.round(dashboardNetValuePercentage)}%</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="carousel-item">
      <div className="row">
        {/* Card 5 */}
        <div className="col-md-3 col-lg-3 stretch-card grid-margin">
          <div className="card bg-gradient-info1 card-img-holder text-white">
            <div className="card-body">
              <img src={Circle} className="card-img-absolute" alt="circle-image" />
              <h4 className="card-title d-flex justify-content-between align-items-center">Sales Count<CiShoppingTag/></h4>
              <h2 className="mb-4">{dashboardNetCount ? dashboardNetCount : 0 }</h2>
              <h6 className="card-text">{dashboardNetCountPercentage > 0 ? "Increased by" : "Decreased by"} {Math.round(dashboardNetCountPercentage)}%</h6>
            </div>
          </div>
        </div>
        {/* Card 6 */}
        <div className="col-md-3 col-lg-3 stretch-card grid-margin">
          <div className="card bg-gradient-sky card-img-holder text-white">
            <div className="card-body">
              <img src={Circle} className="card-img-absolute" alt="circle-image" />
              <h4 className="card-title d-flex justify-content-between align-items-center">Sales call <BiSolidPhoneCall /></h4>
              <h2 className="mb-4">{dashboardSalesCall ? dashboardSalesCall : 0}</h2>
              <h6 className="card-text">Open</h6>
            </div>
          </div>
        </div>
        {/* Card 7 */}
        <div className="col-md-3 col-lg-3 stretch-card grid-margin">
          <div className="card text-white bg-danger-2 card-img-holder">
            <div className="card-body">
              <img src={Circle} className="card-img-absolute" alt="circle-image"/>
              <h4 className="card-title d-flex justify-content-between align-items-center">
                Service Call <RiCustomerService2Line />
              </h4>
              <h2 className="card-text mb-4">{ dashboardServiceCall ? dashboardServiceCall : 0 }</h2>
              <h6 className="card-subtitle mb-2">Open</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Carousel Controls */}
  <button className="carousel-control-prev" type="button" data-bs-target="#dashboardCarousel" data-bs-slide="prev">
    <span className="carousel-control-prev-icon visually-hidden" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#dashboardCarousel" data-bs-slide="next">
    <span className="carousel-control-next-icon visually-hidden" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
        <br/>
        {isCollapsed && (
  <div className="mt-10">
    <div className="row" data-aos="zoom-in-up" data-aos-anchor-placement="center-bottom">
      <div className="col-12 grid-margin">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Recent Invoice</h4>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="thead-dark">
                  <tr>
                    {tableInvoice.length > 0 &&
                      Object.keys(tableInvoice[0]).map(key => (
                        <th key={key} style={{ textAlign: key === 'net_value' ? 'right' : 'center' }}>{key.replace(/_/g, ' ').toUpperCase()}</th>
                      ))}
                  </tr>
                </thead>
                {tableInvoice.length > 0 ? (
                  <tbody>
                    {tableInvoice.map((item, index) => (
                      <tr key={index}>
                        {Object.entries(item).map(([key, value], i) => {
            if (key === 'net_value') {
              // Format net_value as currency
              const formattedValue = new Intl.NumberFormat('en-IN', {
                // style: 'currency',
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(value);
              return (
                <td key={i} style={{ textAlign: 'right' }}>
                  {formattedValue}
                </td>
              );
            } else if (key !== 'PDF') {
              // For other fields except 'PDF'
              return (
                <td key={i} style={{ textAlign: 'center' }}>
                  {value}
                </td>
              );
            }
            return null; // Skip 'PDF' in this map
          })}
                        <td style={{ textAlign: 'center' }}>
                          <a
                            href={`${clientip}/exports/${item.PDF}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            
                          >
                            View PDF
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <div className="text-center" style={{ width: '100%' }}>
                    No data available
                  </div>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-lg-8 col-md-7 col-sm-7 grid-margin stretch-card" data-aos="zoom-in-right">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title float-start">Invoice Values by Month: Last 12 Months</h4>
            <div
              id="visit-sale-chart-legend"
              className="rounded-legend legend-horizontal legend-top-right float-end"
            ></div>
          </div>
          <VisitSaleChart />
        </div>		
      </div>
	   
      {/* <div className="col-md-5 grid-margin stretch-card" data-aos="zoom-in-left">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Traffic Sources</h4>
            <div className="doughnutjs-wrapper d-flex justify-content-center">
              <TrafficChart  />
            </div>
            <div id="traffic-chart-legend" className="rounded-legend legend-vertical legend-bottom-left pt-1"></div>
          </div>
        </div>
      </div> */}
    </div>
  </div>
)}

        <center>
          <button class="learn-more" 
             onClick={() => setIsCollapsed(!isCollapsed)}
            aria-expanded={isCollapsed}
            aria-controls="collapseExample" >
            <span class="circle" aria-hidden="true">
            {isCollapsed ? <span class="icon up-arrow"></span>:<span class="icon down-arrow"></span>}
            {/* {isCollapsed ? <IoIosArrowUp class="icon arrow" /> : <IoIosArrowDown class="icon arrow" />} */}
            </span>
            <span className="button-text">
        {isCollapsed ? "Show Less" : "Show More"}
    </span>
          </button>
        </center>
      </div>
    </div>
  );
};

export default Dashbord;
